export default {
  headerMenu: {
    home: 'Home',
    product: 'Products & Applications',
    resource: 'Models & Data Resources',
    model: 'Shared Models',
    database: 'Shared Databases',
    community: 'Researcher Community',
    publish: 'Papers & Cases',
    subscribe: 'Subscribe',
    about: 'About',
  },
  footerMenu: {
    company: 'Company',
    column: 'About OneBay',
    column1: 'Join Us',
    column2: 'Partners',
    column3: 'Privacy Policy',
    column4: 'Terms of Use',
    column5: 'Contact Us',
  },
  home:{
    loadingText:'Loading...',
    databaseOverview:'Database Overview',
    behaviorSubtype:'Behavior Subtype',
    speciesTotal:'Species Total',
    actionSamples:'Action Samples',
    filterSystem:'Filter System',
    enterPhenomicsAtlasDetail:'Enter PHENOMICSATLAS Detail Page',
    multiSpeciesFeatureComparison:'Multi-Disease Feature Comparison',
    speedDistribution:'Speed Distribution (Including All Diseases Baseline)mm/s',
    bodySizeComparison:'Body Size Comparison (Normalized/Base Comparison)',
    platformDescription:'Multi-Species Behavior Phenomics Data Platform · From Data to Insight, Build the Relationship between Neurobehavior and Phenotype',
  },
  data:{
    noData:'No Data',
    selectSample:'Please select a sample from the left',
    allSelect:'All Select',
    confirmFilters:'Confirm Filters',
    selectedComparison:'Selected Comparison ({count})'
  },
  groupComparisonPanel:{
    title:'Multi-dimensional Behavior and Kinematics Joint Analysis Platform',
    behaviorActionFraction:'20 Action Fraction Dimensionality Reduction (UMAP 3D)',
    dragRotate:'Support Mouse Drag Rotation',
    coreActionDuration:'20 Core Action Group Duration Comparison (FDR &lt; 0.05)',
    kmeansCluster:'K-means Dimensionality Reduction Clustering Scatter Plot',
    envelopeSurface:'Envelope Surface Marking Clusters',
    confusionMatrix:'Confusion Matrix (Confusion Matrix)',
    behaviorRatioCorrelation:'Behavior Ratio Correlation Between Samples',
    bottomColorBand:'Bottom Color Band Indicating Groups',
    allSamplesBehaviorFraction:'All Samples 20 Action Fraction Fingerprint (Fraction Heatmap)',
    bottomColor:'Bottom Color Band Indicating Groups and Sequences',
    ethogram:'Ethogram (Full Action Multi-Sample Behavior Sequence Occurrence Map)',
    filterAction:'Click the Legend Above to Filter Specific Actions',
    BodyGrooming:'Rearing Probability Sequence Distribution',
    confidenceInterval:'Shaded Area is 95% Confidence Interval',
    kinematicParameterComparison:'39 Kinematic Parameter Macroscopic Comparison Analysis',
    bottomSlider:'Support Bottom Slider Zoom to View Sub-features',
    pca3d:'39 Parameter Feature Space (PCA 3D)',
    kmeansConfusionMatrix:'K-means Confusion Matrix',
    radarKinematic:'Distribution of Kinetic Energy Radar at Body Joints',
    kineProbHeatmap:'Kine Probability Heatmap (Core Indicator Distribution Density)',
    microProbDistribution:'Micro Probability Distribution of Speed, Movement Intensity, Body Position, and Body Angle in Each Group (One Sample per Row)',
  }
}
